import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";
import {getQuarterTypeName, getQuarterTypeNamePL, QuarterType} from "../../../property/components/PropertyDetailGeneratedDescriptionFlat";

export const getOfferStatsByQuarterType = (quarterType: QuarterType, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    const quarterName = getQuarterTypeName(quarterType);
    const quarterNamePL = getQuarterTypeNamePL(quarterType);
    const statsValues = stats && quarterName ? stats[`properties_${quarterName}_quarter`] : null;

    return statsValues && statsValues.total
        ? {
              key: quarterName,
              label: quarterNamePL,
              ...statsValues
          }
        : null;
};
import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";
import {getQuarterTypeName, getQuarterTypeNamePL, QuarterType} from "../../../property/components/PropertyDetailGeneratedDescriptionFlat";

export const getOfferStatsByQuarterType = (quarterType: QuarterType, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    const quarterName = getQuarterTypeName(quarterType);
    const quarterNamePL = getQuarterTypeNamePL(quarterType);
    const statsValues = stats && quarterName ? stats[`properties_${quarterName}_quarter`] : null;

    return statsValues && statsValues.total
        ? {
              key: quarterName,
              label: quarterNamePL,
              ...statsValues
          }
        : null;
};
